import { ResponseError } from '../../errors';
import {
  fetchGetConstructorsList,
  IGetConstructorsListRequest,
  TGetConstructorsListResponse,
} from '../../repositories/countryside-constructors/v3/get-constructors-list';
import { IApplicationContext } from '../../types/applicationContext';
import { IBuildersListResponse } from '../../types/builders';

export type IFetchBuildersListParameters = IGetConstructorsListRequest;

export async function fetchBuildersList(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetConstructorsListRequest,
): Promise<IBuildersListResponse | undefined> {
  try {
    const { response, statusCode }: TGetConstructorsListResponse = await fetchGetConstructorsList({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchBuildersList',
        message: response.message || 'Неизвестная ошибка',
      });
    }

    return response;
  } catch (error) {
    logger.warning(error, { degradation: 'Список строительных компаний' });

    return undefined;
  }
}
